import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import Routes from "./routes";
import ErrorBoundary from "./components/common/ErrorBoundary";

class App extends Component {
  render() {
    return (
      <ErrorBoundary fullPage>
        <Switch>
          <Route path="/" component={Routes} />
        </Switch>
      </ErrorBoundary>
    );
  }
}

export default App;
